import { CookieManager, getClientId } from '@unitedtraders/utcom-cookie';

export const cookieManager = new CookieManager();

export { ChangedCookie } from '@unitedtraders/utcom-cookie';

export function getUtClientId() {
  return getClientId(cookieManager, { validAfter: 1592179200000 }); //2020-06-15T00:00:00Z+0 read INVEST-1527
}
